import { Analytics } from '../utils/analytics';
import { AnalyticsUtils } from '../utils/analytics/AnalyticsUtils';
import { AnalyticsType } from '../types/Analytics';
const toLowerCase = (eventProperties) => {
    return Object.fromEntries(Object.entries(eventProperties)
        .map(([k, v]) => {
        return [k, typeof v === 'string' ? v.toLowerCase() : v];
    }));
};
export const sendRudderStackAnalyticsEvent = (eventInfo) => {
    const eventName = eventInfo.eventName;
    const eventProperties = eventInfo?.eventProperties ?? {};
    const userProperties = eventInfo?.userProperties ?? {};
    if (AnalyticsUtils.getIsEligibleForRudderstackAnalytics()) {
        return Analytics.send(AnalyticsType.RUDDER_STACK, {
            eventName,
            eventProperties: {
                ...AnalyticsUtils.commonRudderStackEventProperties(),
                ...toLowerCase(eventProperties),
            },
            userProperties: {
                ...toLowerCase(userProperties ?? {}),
            },
        });
    }
    else {
        return Promise.resolve();
    }
};
